export const MESSAGING_WINDOW_24_HOURS = 24 * 60 * 60;

export const MESSAGING_WINDOW_CHANNEL_TYPES = [
  'Channel::Whatsapp',
  'Channel::Iungo',
];

export const MESSAGING_WINDOW_CHAT_MESSAGE_TYPES = [0, 1, 3];

export const hasMessagingWindowTimer = (channelType, medium = '') => {
  if (MESSAGING_WINDOW_CHANNEL_TYPES.includes(channelType)) {
    return true;
  }

  return channelType === 'Channel::Twilio' && medium === 'whatsapp';
};

export const isMessagingWindowChatMessage = message =>
  !message.private &&
  MESSAGING_WINDOW_CHAT_MESSAGE_TYPES.includes(message.message_type);

export const getRemainingSeconds = expiresAt => {
  if (!expiresAt) return 0;

  return Math.max(0, expiresAt - Math.floor(Date.now() / 1000));
};

export const customerHasMessagedInConversation = conversation => {
  if (!conversation) return false;

  if (conversation.messaging_window_expires_at) return true;

  const messages = conversation.messages || [];
  return messages.some(
    message =>
      message.message_type === 0 &&
      !message.private &&
      message.status !== 'failed'
  );
};

export const isMessagingWindowActive = conversation => {
  if (!conversation?.messaging_window_expires_at) return false;

  return getRemainingSeconds(conversation.messaging_window_expires_at) > 0;
};

export const shouldRefreshMessagingWindow = (message, conversation) => {
  if (!isMessagingWindowChatMessage(message)) return false;

  if (message.message_type === 0) return true;

  return (
    customerHasMessagedInConversation(conversation) &&
    isMessagingWindowActive(conversation)
  );
};

export const buildMessagingWindowExpiresAt = message =>
  message.created_at + MESSAGING_WINDOW_24_HOURS;

export const formatRemainingTime = totalSeconds => {
  const safeSeconds = Math.max(0, totalSeconds);
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;

  return [hours, minutes, seconds]
    .map(value => String(value).padStart(2, '0'))
    .join(':');
};

export const mergeMessagingWindowExpiresAt = (currentValue, nextValue) => {
  if (!nextValue) return currentValue;
  if (!currentValue) return nextValue;

  return Math.max(currentValue, nextValue);
};
